import React, { Suspense, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import configureStore from "./config";
import ScrollToTop from "./ScrollToTop";

import "react-pagination-js/dist/styles.css";
import "react-toastify/dist/ReactToastify.css";
import "react-circular-progressbar/dist/styles.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-phone-input-2/lib/style.css";
import "react-quill/dist/quill.snow.css";
import { Auth } from "./methods/auth";

import { createBrowserHistory } from "history";
export const history = createBrowserHistory();
import Login from "./pages/Login";
import Forgotpassword from "./pages/Forgotpassword";
import Resetpassword from "./pages/Resetpassword";
import ChangePassword from "./pages/Profile/ChangePassword";
import ViewProfile from "./pages/Profile/ViewProfile";
import EditProfile from "./pages/Profile/EditProfile";
import { Logo } from "./actions/Logo";
import ApiClient from "./methods/api/apiClient";
import methodModel from "./methods/methods";
import noPages from "./pages/404";
import environment from "./environment/index.js";
import { store_chatbot_data } from "./actions/chatbot.js";
import ChatBot from "./pages/ChatBot";
import ProductsIndex from "./pages/ChatBot/Tabs/Products/ProductList.js";
import Equipment from "./pages/Equipment";
import Manufacturer from "./pages/Manufacturer";
import QuoteList from "./pages/Quote/QuoteList.js";
import ContactUsList from "./pages/ContactUs/ContactUsList.jsx";
import ContactUsDetail from "./pages/ContactUs/ContactUsDetail.jsx";
import PlansList from "./pages/Plans/PlansList.jsx";
import PlanAddEdit from "./pages/Plans/PlanAddEdit.jsx";
import PlanDetail from "./pages/Plans/PlanDetail.jsx";
import TransactionsList from "./pages/Transactions/TransactionsList.jsx";
import TransactionDetail from "./pages/Transactions/TransactionDetail.jsx";
import TenantsList from "./pages/Tenants/TenantsList.jsx";
import TenantAddEdit from "./pages/Tenants/TenantAddEdit.jsx";
import TenantDetail from "./pages/Tenants/TenantDetail.jsx";
import StaffList from "./pages/Staff/StaffList.jsx";
import StaffAddEdit from "./pages/Staff/StaffAddEdit.jsx";
import StaffDetail from "./pages/Staff/StaffDetail.jsx";
import EmailTemplatesList from "./pages/EmailTemplates/EmailTemplatesList.jsx";
import EmailTemplateAddEdit from "./pages/EmailTemplates/EmailTemplateAddEdit.jsx";
import EmailTemplateDetail from "./pages/EmailTemplates/EmailTemplateDetail.jsx";
import UsersListing from "./pages/Users/UsersListing.js";
import TakePayment from "./pages/TakePayment/index.js";
import QuickBookIntegration from "./pages/QuickBooks/QuickBookIntegration.jsx";
import QuickBookInvoiceList from "./pages/QuickBooks/InvoiceList.jsx";
import QuickBookCustomerList from "./pages/QuickBooks/CustomersList.jsx";
import QuickBookInvoiceAdd from "./pages/QuickBooks/QuickBookInvoiceAdd.jsx";
import QuickBookItemList from "./pages/QuickBooks/QuickBookProductList.jsx";
import QuickBookEstimateList from "./pages/QuickBooks/QuickBookEstimate.jsx";
import QuickBookEstimateAdd from "./pages/QuickBooks/QuickBookEstimateAdd.jsx";

import RequestQuoteListing from "./pages/Quote/RequestQuoteListing.jsx";
import GenerateQuote from "./pages/Quote/GenerateQuote.js";
import OrderMgmt from "./pages/OrderManagement/OrderMgmt.jsx";
import GenerateInvoice from "./pages/QuickBooks/GenerateInvoice.jsx";
import EditQuote from "./pages/Quote/EditQuote.js";
import Dashboard from "./pages/Dashboard/index.js";
import OrderTrackingList from "./pages/OrderTracking/OrderTrackingList.jsx";
import OrderTrackingDetail from "./pages/OrderTracking/OrderTrackingDetail.jsx";
import QuickBookEstimateDetail from "./pages/QuickBooks/QuickBookEstimateDetail.jsx";
import QuickBookInvoiceDetail from "./pages/QuickBooks/QuickBookInvoiceDetail.jsx";

// ── QB Desktop ──
import QBDCustomerList from "./pages/DesktopQuickBook/QBDCustomerList.jsx";
import QBDCustomerAdd from "./pages/DesktopQuickBook/QBDCustomerAdd.jsx";
import QBDProductList from "./pages/DesktopQuickBook/QBDProductList.jsx";
import QBDEstimateList from "./pages/DesktopQuickBook/QBDEstimateList.jsx";
import QBDEstimateAdd from "./pages/DesktopQuickBook/QBDEstimateAdd.jsx";
import QBDEstimateDetail from "./pages/DesktopQuickBook/QBDEstimateDetail.jsx";
import QBDInvoiceList from "./pages/DesktopQuickBook/QBDInvoiceList.jsx";
import QBDInvoiceAdd from "./pages/DesktopQuickBook/QBDInvoiceAdd.jsx";
import QBDQueueStatus from "./pages/DesktopQuickBook/QBDQueueStatus.jsx";

const { store } = configureStore(history);

export default () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(Logo("Logo"));
  }, []);

  return (
    <>
      <Suspense
        fallback={
          <div>
            <div id="loader" className="loaderDiv">
              <div>
                <img
                  src="/assets/img/loader.gif"
                  alt="logo"
                  className="pageLoader"
                  width="auto"
                  height="auto"
                />
              </div>
            </div>
          </div>
        }
      >
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path="/chatbot" element={<ChatBot />} />
            <Route path="/products" element={<ProductsIndex />} />
            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/equipment" element={<Equipment />} />

            <Route path="/manufacturer" element={<Manufacturer />} />
            <Route path="/users" element={<UsersListing />} />

            <Route path="/profile" element={<ViewProfile />} />
            <Route path="/profile/view" element={<ViewProfile />} />
            <Route path="/profile/edit" element={<EditProfile />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/profile/change-password" element={<ChangePassword />} />
            <Route path="/forgotpassword" element={<Forgotpassword />} />
            <Route path="/resetpassword" element={<Resetpassword />} />
            <Route path="/reset-password" element={<Resetpassword />} />
            <Route path="/quote/requests" element={<QuoteList />} />
            <Route path="/request-quotes" element={<RequestQuoteListing />} />
            <Route path="/contact-us" element={<ContactUsList />} />
            <Route path="/contact-us/detail/:id" element={<ContactUsDetail />} />
            <Route path="/contactus/requests" element={<ContactUsList />} />
            <Route path="/plans" element={<PlansList />} />
            <Route path="/plans/add" element={<PlanAddEdit />} />
            <Route path="/plans/edit/:id" element={<PlanAddEdit />} />
            <Route path="/plans/detail/:id" element={<PlanDetail />} />
            <Route path="/transactions" element={<TransactionsList />} />
            <Route path="/transactions/detail/:id" element={<TransactionDetail />} />
            <Route path="/tenants" element={<TenantsList />} />
            <Route path="/tenants/add" element={<TenantAddEdit />} />
            <Route path="/tenants/edit/:id" element={<TenantAddEdit />} />
            <Route path="/tenants/detail/:id" element={<TenantDetail />} />
            <Route path="/staff" element={<StaffList />} />
            <Route path="/staff/add" element={<StaffAddEdit />} />
            <Route path="/staff/edit/:id" element={<StaffAddEdit />} />
            <Route path="/staff/detail/:id" element={<StaffDetail />} />
            <Route path="/sub-administrators" element={<StaffList />} />
            <Route path="/sub-administrators/add" element={<StaffAddEdit />} />
            <Route path="/sub-administrators/edit/:id" element={<StaffAddEdit />} />
            <Route path="/sub-administrators/detail/:id" element={<StaffDetail />} />
            <Route path="/email-templates" element={<EmailTemplatesList />} />
            <Route path="/email-templates/add" element={<EmailTemplateAddEdit />} />
            <Route path="/email-templates/create" element={<EmailTemplateAddEdit />} />
            <Route path="/email-templates/edit/:id" element={<EmailTemplateAddEdit />} />
            <Route path="/email-templates/detail/:id" element={<EmailTemplateDetail />} />
            <Route path="/take/payment" element={<TakePayment />} />
            <Route
              path="/quickbook/integration"
              element={<QuickBookIntegration />}
            />
            <Route
              path="/quickbook/invoices"
              element={<QuickBookInvoiceList />}
            />
            <Route
              path="/quickbook/invoices/add"
              element={<QuickBookInvoiceAdd />}
            />
            <Route
              path="/quickbook/customers"
              element={<QuickBookCustomerList />}
            />
            <Route path="/quickbook/products" element={<QuickBookItemList />} />
            <Route
              path="/quickbook/estimates"
              element={<QuickBookEstimateList />}
            />
            <Route
              path="/quickbook/estimates/add"
              element={<QuickBookEstimateAdd />}
            />
            <Route path="/order/management" element={<OrderMgmt />} />
            <Route path="/order/tracking" element={<OrderTrackingList />} />
            <Route
              path="/order/tracking/detail/:id"
              element={<OrderTrackingDetail />}
            />
            <Route
              path="/generate/invoice/:id?"
              element={<GenerateInvoice />}
            />
            <Route
              path="/estimate/detail/:id?"
              element={<QuickBookEstimateDetail />}
            />
            <Route
              path="/invoice/detail/:id?"
              element={<QuickBookInvoiceDetail />}
            />
            <Route
              path="/generate/quote/:requestQuoteId?"
              element={<GenerateQuote />}
            />
            <Route
              path="/edit/quote/:requestQuoteId?"
              element={<EditQuote />}
            />

            <Route path="*" element={noPages} />

            {/* ── QB Desktop Routes ── */}
            <Route path="/qb-desktop/customers" element={<QBDCustomerList />} />
            <Route path="/qb-desktop/customers/add" element={<QBDCustomerAdd />} />
            <Route path="/qb-desktop/products" element={<QBDProductList />} />
            <Route path="/qb-desktop/estimates" element={<QBDEstimateList />} />
            <Route path="/qb-desktop/estimates/add" element={<QBDEstimateAdd />} />
            <Route path="/qb-desktop/estimates/detail/:id?" element={<QBDEstimateDetail />} />
            <Route path="/qb-desktop/invoices" element={<QBDInvoiceList />} />
            <Route path="/qb-desktop/invoices/add" element={<QBDInvoiceAdd />} />
            <Route path="/qb-desktop/queue-status" element={<QBDQueueStatus />} />
          </Routes>
        </Router>
      </Suspense>
      {/* <VoiceWidget/> */}
      <button
        id="playAudio"
        style={{ display: "none" }}
        onClick={(e) => {
          new Audio("/assets/notification.mp3").play();
        }}
      >
        Play Audio
      </button>
      {/* Chanegs  */}
      <audio src="/assets/notification.mp3" id="audioFile" />
      <iframe
        id="audioPlayer"
        style={{ display: "none" }}
        allow="autoplay"
      ></iframe>

      <div id="loader" className="loaderDiv !hidden">
        <div>
          <img
            src="/assets/img/loader.gif"
            width="auto"
            height="auto"
            alt="logo"
            className="pageLoader"
          />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
